module.exports = __webpack_public_path__ + "img/122.d03a2d29.gif";